// extracted by mini-css-extract-plugin
export default {"background":"Profile_background__v5xuG","box":"Profile_box__HOygI","name":"Profile_name__lLfqC","github":"Profile_github__fVbSC","linkedin":"Profile_linkedin__+uw+K"};